import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import { useTranslation } from 'react-i18next';
import { createTheme, ThemeProvider } from '@mui/material/styles';


function Basic({answers}) {
    const {t} = useTranslation('global');


    const getMuiTheme = () => createTheme({
        components: {
            MuiTableContainer:{
                styleOverrides:{
                    root: {
                        border:'1px solid #ccc',
                        borderRadius: '5px',
                        fontFamily: 'Open Sans'
                    }
                }
            },
            MuiTableCell:{
                styleOverrides:{
                  root: {
                    lineHeight:'16px',
                    fontFamily: 'Open Sans'
                  }
                }
              },
        }
    })

  return (
    <div style={{width:'34%', marginRight:'5px'}}>
        <ThemeProvider theme={getMuiTheme()}>
            <TableContainer 
          
            >
                <Table  size="small"
                sx={{
                borderCollapse: "collapse",
                borderStyle: "hidden",
                "& td": {
                    border:'1px solid #CCC'
                }
                }} 
                >
                    <TableHead  sx={{
                    "& th": {
                    backgroundColor: "#def1fc",
                    color: "black",
                    fontWeight:600,
                    },
                    "& th:hover": {
                    backgroundColor: "#c9e8fa",
                    }
                }}>
                        <TableRow> 
                            <TableCell>{t('questions')}</TableCell>
                            <TableCell>{t('answers')}</TableCell>
                        </TableRow>                        
                    </TableHead>
                    <TableBody>
                    {answers?.height && 
                        <TableRow> 
                            <TableCell>
                               
                                {answers?.height?.question}
                            </TableCell>
                            <TableCell>
                            {answers?.height?.answer}
                               
                            </TableCell>
                        </TableRow> 
                    }
                    {answers?.curWeight &&
                         <TableRow> 
                            <TableCell>
                               
                                {answers?.curWeight?.question}
                            </TableCell>
                            <TableCell>
                                {answers?.curWeight?.answer} 
                            </TableCell>
                        </TableRow> 
                    }   

                    {answers?.goalWeight &&    
                        <TableRow> 
                            <TableCell>
                               
                                {answers?.goalWeight?.question} 
                            </TableCell>
                            <TableCell>
                                {answers?.goalWeight?.answer} 
                            </TableCell>
                        </TableRow> 
                    }

                    {answers?.relationship &&
                       <TableRow> 
                            <TableCell>
                               
                                {answers?.relationship?.question} 
                            </TableCell>
                            <TableCell>
                                {answers?.relationship?.answer}  
                            </TableCell>
                        </TableRow> 
                    }

                    {answers?.education &&
                        <TableRow> 
                            <TableCell>
                               
                                {answers?.education?.question}  
                            </TableCell>
                            <TableCell>
                                {answers?.education?.answer}  
                            </TableCell>
                        </TableRow> 
                    }

                    {answers?.ethnicity &&
                        <TableRow> 
                            <TableCell>
                               
                                {answers?.ethnicity?.question}  
                            </TableCell>
                            <TableCell>
                                {answers?.ethnicity?.answer}  
                            </TableCell>
                        </TableRow> 
                    }

                    {answers?.pregnant &&
                        <TableRow> 
                            <TableCell>
                              
                                {answers?.pregnant?.question}
                            </TableCell>
                            <TableCell>
                                {answers?.pregnant?.answer}
                            </TableCell>
                        </TableRow> 
                    }

                    {answers?.treatmentJoint &&
                        <TableRow> 
                            <TableCell>
                               
                                {answers?.treatmentJoint?.question} 
                            </TableCell>
                            <TableCell>
                                {answers?.treatmentJoint?.answer} 
                            </TableCell>
                        </TableRow> 
                    }

                    {answers?.painSince &&
                        <TableRow> 
                            <TableCell>
                               
                                {answers?.painSince?.question} 
                            </TableCell>
                            <TableCell>
                                {answers?.painSince?.answer} 
                            </TableCell>
                        </TableRow> 
                    }

                    {answers?.hoursWork &&
                        <TableRow> 
                            <TableCell>
                               
                                {answers?.hoursWork?.question} 
                            </TableCell>
                            <TableCell>
                                {answers?.hoursWork?.answer} 
                            </TableCell>
                        </TableRow> 
                    }

                    {answers?.pendingSurgery && 
                        <TableRow>  
                            <TableCell>
                                
                                {answers?.pendingSurgery?.question} 
                            </TableCell>
                            <TableCell>
                                {answers?.pendingSurgery?.answer} 
                            </TableCell>
                        </TableRow>
                    }

                    {answers?.exerciseDays &&
                        <TableRow> 
                            <TableCell>
                               
                                {answers?.exerciseDays?.question}
                            </TableCell>
                            <TableCell>
                                {answers?.exerciseDays?.answer} 
                            </TableCell>
                        </TableRow>
                    }

                    {answers?.exerciseHours &&
                        <TableRow> 
                            <TableCell>
                               
                                {answers?.exerciseHours?.question} 
                            </TableCell>
                            <TableCell>
                                {answers?.exerciseHours?.answer} 
                            </TableCell>
                        </TableRow> 
                    }
                    {answers === null && 
                        <TableRow> 
                            <TableCell colSpan={2}> No data to display</TableCell>
                        </TableRow>
                    }
                    </TableBody>
                </Table>
            </TableContainer>
        </ThemeProvider>
    </div>
  )
}

export default Basic